import { splitStringBySeparator } from '~/helpers'
import { EVENT_VIEWS } from '~/constants'

export default {
  setEventViewFilters ({ commit }, { eventView, filters }) {
    commit('setEventViewFilters', { eventView, filters })
  },

  resetEventViewFilters ({ commit, getters }, eventView) {
    const filters = getters.defaultFilters(eventView)
    commit('setEventViewFilters', { eventView, filters })
  },

  resetAllEventViewFilters ({ dispatch }) {
    Object.keys(EVENT_VIEWS).forEach(eventView => {
      dispatch('resetEventViewFilters', eventView)
    })
  },

  rehydrateEventViewFilters ({ commit, getters }, { eventView, query }) {
    if (eventView && query) {
      const eventViewFilters = getters.eventViewFilters(eventView)
      const filters = Object.entries(query).reduce((acc, [key, val]) => ({
        ...acc,
        [key]: Array.isArray(eventViewFilters[key]) ? splitStringBySeparator(val) : val
      }), {})

      commit('setEventViewFilters', { eventView, filters })
    }
  },

  updateLocationFilters ({ commit, rootGetters, state }, { prevFavHouses }) {
    const houses = state.filters.houses
    const favHouses = rootGetters['user/account/favoriteVenues'].map(h => h.id)

    prevFavHouses.forEach(h => {
      if (!favHouses.includes(h) && houses.includes(h)) {
        houses.splice(houses.indexOf(h), 1)
      }
    })
    favHouses.forEach(h => {
      if (!prevFavHouses.includes(h) && !houses.includes(h)) {
        houses.push(h)
      }
    })

    commit('setLocationFilters', { houses })
  }
}
